import { useMutation, useQueryClient } from "react-query";

import {
  MarketingGroupAddRemovePerson,
  MarketingGroupCreate,
} from "../../models/marketingGroup/MarketingGroup";
import useApiHelper from "../../services/useApiHelper";
import { marketingGroupQueryKeys } from "./queryKeys";
import useDefaultCRUDHandlers from "../../hooks/useDefaultCRUDHandlers";
import { peopleQueryKeys } from "../people/queryKeys";

export function useMarketingGroupMutations() {
  const queryClient = useQueryClient();
  const { del, post } = useApiHelper();
  const { saveHandlers } = useDefaultCRUDHandlers("Marketing Group");
  const { deleteHandlers } = useDefaultCRUDHandlers("Marketing Group Member");

  const create = useMutation(
    (marketingGroup: MarketingGroupCreate) =>
      post(`/marketing/group`, marketingGroup),
    {
      ...saveHandlers,
      onSuccess: () => {
        queryClient.invalidateQueries(marketingGroupQueryKeys._base());
        saveHandlers.onSuccess?.();
      },
    }
  );

  const addPeople = useMutation(
    (data: MarketingGroupAddRemovePerson) =>
      post(`/marketing/group/${data.marketingGroupId}/member`, data.data),
    {
      ...saveHandlers,
      onSuccess: (_, updateData) => {
        queryClient.invalidateQueries(marketingGroupQueryKeys._base());
        updateData.data.people.forEach((personId) => {
          queryClient.refetchQueries(peopleQueryKeys.single(personId));
        });
        saveHandlers.onSuccess?.();
      },
    }
  );

  const removePeople = useMutation(
    (data: MarketingGroupAddRemovePerson) =>
      del(`/marketing/group/${data.marketingGroupId}/member`, data.data),
    {
      ...deleteHandlers,
      onSuccess: (_, updateData) => {
        queryClient.invalidateQueries(marketingGroupQueryKeys._base());
        updateData.data.people.forEach((personId) => {
          queryClient.refetchQueries(peopleQueryKeys.single(personId));
        });
        deleteHandlers.onSuccess?.();
      },
    }
  );

  return {
    create,
    addPeople,
    removePeople,
  };
}
